import React from 'react';
import {buildClickTrackingUrl} from '../_Global/searchHelpers';

interface ResultPeopleConfiguration {
    result: SearchResult;
}

/**
 * Used to render a result card
 *
 * @param {result}
 * @returns
 */
function ResultPeople({result}: ResultPeopleConfiguration) {
    const role = result['listMetadata']['rolePreferred'] ?? result['listMetadata']['role'];

    return (
        <div key={result['rank']} className="card card--profile no-wysiwyg col-span-4 xs:col-span-6 sm:col-span-4 md:col-span-3">
            <a href={buildClickTrackingUrl(result['clickTrackingUrl'])}>
                <div className="card__copy-gradient">
                    <div
                        className="card__copy"
                        style={{
                            backgroundImage: `url("${result['listMetadata']['imageUrl']}")`,
                        }}
                    >
                        <div className="card__container">
                            <div className="card__bottom">
                                <h3 className="card__heading body-size-xl">
                                    {result['listMetadata']['namePreferred'] ?? result['listMetadata']['nameFirst']} {result['listMetadata']['nameLast']}
                                </h3>
                            </div>
                            <div className="card__block">
                                <div className="card__metadata metadata-wrapper metadata-wrapper--inline">
                                    <div className="body-default">{role}</div>
                                    <div className="body-default">{result['listMetadata']['location']}</div>
                                </div>
                                <div className="card__arrow-link">
                                    <svg role="graphics-symbol">
                                        <use xlinkHref="#arrow-diagonal"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}

/**
 * Create the markup for this people result.
 */
export default React.memo(ResultPeople);
